import { Injectable } from '@angular/core';
import { combineQueries, ID, QueryEntity } from '@datorama/akita';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { CrowdCountObservedQuery } from './crowd-count-observed.query';
import { CrowdFlowROIState, CrowdFlowROIStore } from './crowd-flow-roi.store';
import { CrowdFlowSensorSiteQuery } from './crowd-flow-sensor-site.query';
import { CrowdFlowsObservedQuery } from './crowd-flows-observed.query';

@Injectable({ providedIn: 'root' })
export class CrowdFlowROIQuery extends QueryEntity<CrowdFlowROIState> {

  constructor(
    protected store: CrowdFlowROIStore,
    private crowdFlowQuery: CrowdFlowsObservedQuery,
    private crowdFlowSensorSiteQuery: CrowdFlowSensorSiteQuery,
    private crowdCountObservedQuery: CrowdCountObservedQuery) {
    super(store);
  }

  selectAllCrowdFlowsForSingleRoi(roiID: ID) {
    const data = combineQueries([this.selectEntity(roiID), this.crowdFlowQuery.selectAll({ asObject: true })]
    ).pipe(
      map(([roi, allCrowdFlows]) => ({
        ...roi,
        crowdFlows: roi.edgeIds.map(id => allCrowdFlows[id])
      })
      ));

    return data;
  }

  selectAllSensorSitesWithoutROIs() {
    const sensorSitesWithROI = this.selectAll().pipe(map(all => all.map(x => x.sensorSiteId)));
    const allsensorSitesIds = this.crowdFlowSensorSiteQuery.selectAll();

    return sensorSitesWithROI.pipe(
      switchMap(() => combineLatest([allsensorSitesIds, sensorSitesWithROI]).pipe(
          map(([all, withRois]) => all.filter(sensorSites => !withRois.includes(sensorSites.id))),
        ))
    );
  }

  selectAllROIWithCrowdCountObserved() {
    const data = combineQueries([this.selectAll(), this.crowdCountObservedQuery.selectAll({ asObject: true })]
    ).pipe(
      map(([rois, crowdCounts]) => rois.map(roi => ({
            ...roi,
            crowdCountObserved: crowdCounts[roi.crowdCountObservedId]
          }))
      ));

    return data;
  }

  selectROIWithCrowdCountObserved(roiID: ID) {

    const entity$ = this.selectEntity(roiID).pipe(filter(entity => entity !== undefined));
    const data = combineQueries([entity$, this.crowdCountObservedQuery.selectAll({ asObject: true })]
    ).pipe(
      map(([roi, crowdCounts]) => ({
        ...roi,
        crowdCountObserved: crowdCounts[roi.crowdCountObservedId]
      })
      ));
    return data;
  }


  roisByEdge$(edgeId: string | number) {
    return this.selectAll({
      filterBy: roi => roi.edgeIds.includes(edgeId),
      limitTo: 1
    });

  }




}
